var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLockIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#lockIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 10c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-6c0-1.103-.897-2-2-2H7Zm6 4v2a.999.999 0 1 1-2 0v-2a.999.999 0 1 1 2 0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 6a2.5 2.5 0 0 0-2.5 2.5V10h-2V8.5a4.501 4.501 0 0 1 9 0V10h-2V8.5A2.5 2.5 0 0 0 12 6Z",
  opacity: 0.8
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "lockIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5 4h14v16H5z"
})))));
export default SvgLockIcon;